import React from "react";
import HeroImage from "../../src/assets/hero.png";
import { useNavigate } from "react-router-dom"; // ✅ Import navigation hook


const Landing = () => {
  const navigate = useNavigate(); // ✅ Initialize navigate

  return (
    <section className="bg-[#FFE7D6] w-full flex flex-col md:flex-row relative overflow-hidden px-5 sm:px-8 md:px-16 pt-24 sm:pt-28 md:pt-10 font-sans md:min-h-[100vh]">

{/* Left Text Content */}
<div className="w-full md:w-1/2 flex flex-col justify-center items-center md:items-start 
text-center md:text-left space-y-5 z-10 relative">
  <h1 className="font-bricolage text-3xl sm:text-4xl md:text-5xl font-bold text-black leading-snug sm:leading-tight">
    Making Mathematics <br />
    <span className="text-[#F15A29]">Simple & Achievable</span>
  </h1>

  <p className="text-gray-700 text-sm sm:text-base md:text-lg max-w-sm sm:max-w-md">
    Helping students master every semester’s mathematics and excel in their exams.
  </p>

  <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
    <button
      onClick={() => navigate("/courses")}
      className="bg-[#1E90FF] hover:bg-[#1877CC] text-white px-6 py-3 rounded-full transition-all shadow-sm text-sm sm:text-base"
    >
      View all courses
    </button>
    <button
      onClick={() => window.open("https://www.youtube.com/@btechmathematics", "_blank")}
      className="border border-[#FE753F] text-[#FE753F] hover:bg-[#FE753F] hover:text-white px-6 py-3 rounded-full transition-all shadow-sm text-sm sm:text-base"
    >
      Subscribe to YouTube
    </button>
  </div>
</div>

{/* Hero Image Section */}
<div className="w-full md:w-1/2 flex justify-center md:justify-end items-end relative z-10 mt-10 md:mt-0">
  <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-0">
    {/* Decorative Circles */}
    <div className="absolute w-[650px] sm:w-[680px] h-[650px] sm:h-[680px] rounded-full border border-[#F8B68B] opacity-50"></div>
    <div className="absolute w-[500px] sm:w-[520px] h-[500px] sm:h-[520px] rounded-full border border-[#F8B68B] opacity-50"></div>
    <div className="absolute w-[380px] sm:w-[380px] h-[380px] sm:h-[380px] rounded-full border border-[#F8B68B] opacity-50"></div>
    <div className="absolute w-[250px] sm:w-[250px] h-[250px] sm:h-[250px] rounded-full border border-[#F8B68B] opacity-50"></div>
  </div>

  <img
    src={HeroImage}
    alt="Instructor"
    className="w-60 sm:w-72 md:w-[420px] object-contain drop-shadow-xl"
  />
</div>

    </section>
  );
};

export default Landing;
